// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IAOBH","label":"styles_label__Ik9IL"};